import CheckedIcon from '@mui/icons-material/Check';
import { Box, ToggleButton, Typography } from '@mui/material';
import {
  CommStatus,
  commStatuses,
  CommType,
  commTypes,
  IInboxFilter
} from '../../../../hooks/use-inbox/use-inbox-filter';
import { FilterToggleButtonGroup } from '../../../shared/filter/filter.styles';
import { InboxSectionSeparator, OverlineText } from '../inbox-widget/styles/inbox-styles';
import { FilterContainer } from './styles/inbox-filter-styles';

interface InboxFilteringPanelProps {
  filterPre: IInboxFilter;
  onFilterPreselected: (filterPre: Partial<IInboxFilter>) => void;
}

export default function InboxFilteringPanel({ filterPre, onFilterPreselected }: InboxFilteringPanelProps) {
  const onCommTypeChange = (_event: React.MouseEvent<HTMLElement>, newCommType: CommType) => {
    onFilterPreselected({ commType: newCommType });
  };

  const onCommStatusesChange = (_event: React.MouseEvent<HTMLElement>, newStatuses: CommStatus[]) => {
    onFilterPreselected({ commStatuses: newStatuses });
  };

  return (
    <FilterContainer>
      <InboxSectionSeparator>
        <OverlineText variant="overline">Channel</OverlineText>
      </InboxSectionSeparator>
      <Box>
        <FilterToggleButtonGroup
          value={filterPre.commType}
          exclusive
          onChange={onCommTypeChange}
          aria-label="communication type"
        >
          {commTypes.map((commType, index) => (
            <ToggleButton key={index} value={commType}>
              {filterPre.commType === commType && <CheckedIcon sx={{ fontSize: 'small', mr: 1 }} />}
              <Typography variant="body2" textTransform="none" color="#0259AB">
                {commType}
              </Typography>
            </ToggleButton>
          ))}
        </FilterToggleButtonGroup>
      </Box>
      <InboxSectionSeparator>
        <OverlineText variant="overline">Status</OverlineText>
      </InboxSectionSeparator>
      <Box>
        <FilterToggleButtonGroup value={filterPre.commStatuses} onChange={onCommStatusesChange} aria-label="statuses">
          {commStatuses.map((commStatus, index) => (
            <ToggleButton key={index} value={commStatus}>
              {filterPre.commStatuses?.includes(commStatus) && <CheckedIcon sx={{ fontSize: 'small', mr: 1 }} />}
              <Typography variant="body2" textTransform="none" color="#0259AB">
                {commStatus}
              </Typography>
            </ToggleButton>
          ))}
        </FilterToggleButtonGroup>
      </Box>
    </FilterContainer>
  );
}
